import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext, Trans } from "@hopper-b2b/i18n";
import clsx from "clsx";
import styles from "./OfferTerms.module.scss";

export interface OfferTermsProps {
  className?: string;
}

/**
 * Offer terms & conditions footer for the hotel funded offers page. Copy lives
 * in i18n (`hotelFundedOffersPage.terms.*`) with `<p>` tags mapped via Trans.
 * `parent={null}` keeps those paragraphs as direct children of `__body` so
 * flex gap applies between them.
 */
export const OfferTerms = ({ className }: OfferTermsProps) => {
  const [block, cn] = useModuleBEM(styles, "OfferTerms");
  const { t } = useI18nContext();

  return (
    <section className={clsx(block, className)}>
      <h2 className={cn("title")}>{t("hotelFundedOffersPage.terms.title")}</h2>
      <div className={cn("body")}>
        <Trans
          parent={null}
          i18nKey="hotelFundedOffersPage.terms.body"
          components={[<p className={cn("paragraph")} />]}
        />
      </div>
    </section>
  );
};
